import {EChartsOption} from 'echarts';
import {DateTime} from 'luxon';
import {DateUtils} from '../utilities/date-time-helpers';

export const chartExpandIcon = 'path://m19.45 19.9-6.25-6.25q-.75.65-1.725 1Q10.5 15 9.55 15q-2.3 0-3.9-1.6t-1.6-3.9q0-2.3 1.6-3.9T9.55 4q2.3 0 3.9 1.6t1.6 3.9q0 1.025-.375 2-.375.975-.975 1.65l6.25 6.25Zm-9.9-5.6q2.025 0 3.413-1.388Q14.35 11.525 14.35 9.5t-1.387-3.413Q11.575 4.7 9.55 4.7T6.138 6.087Q4.75 7.475 4.75 9.5t1.388 3.412Q7.525 14.3 9.55 14.3Z';
export const chartBarIcon = 'path://M4.65 19.35v-9.7h2.7v9.7Zm6 0V4.65h2.7v14.7Zm6 0v-5.7h2.7v5.7Z';
export const chartPieIcon = 'path://M12.35 11.65H20q-.15-3.125-2.337-5.325Q15.475 4.125 12.35 4Zm-.7 8.35V4q-3.2.125-5.425 2.438Q4 8.75 4 12q0 3.25 2.225 5.562Q8.45 19.875 11.65 20Zm.7 0q3.125-.125 5.313-2.325 2.187-2.2 2.337-5.325h-7.65ZM12 12Zm0 8.7q-1.8 0-3.387-.688-1.588-.687-2.763-1.862-1.175-1.175-1.863-2.763Q3.3 13.8 3.3 12t.687-3.388Q4.675 7.025 5.85 5.85t2.763-1.863Q10.2 3.3 12 3.3t3.388.687q1.587.688 2.762 1.863t1.863 2.762Q20.7 10.2 20.7 12q0 1.8-.687 3.387-.688 1.588-1.863 2.763-1.175 1.175-2.762 1.862Q13.8 20.7 12 20.7Z';

export const chartDefaultOptions: EChartsOption = {
  legend: {
    show: true,
    type: 'scroll',
    orient: 'horizontal',
    top: 40,
    itemStyle: {
      borderCap: 'round',
    }
  },
  title: {
    show: true,
    textStyle: {
      color: 'rgba(26, 36, 81, 0.87)',
      fontSize: '18px',
      fontWeight: 500,
      fontFamily: '\'Inter\', sans-serif'
    }
  },
  grid: {
    left: '60',
    right: '60',
    bottom: '80',
    top: '90'
  },
};

export function getWeekendsArea(startDate: Date, endDate: Date) {
  const weekends = getWeekends(startDate, endDate);
  const weekendData = [];

  for (let i = 0; i < weekends.length; i = i + 2) {
    weekendData.push([
      {
        name: 'WE',
        xAxis: weekends[i]
      },
      {
        xAxis: weekends[i + 1] || weekends[i]
      }
    ]);
  }

  return {
    itemStyle: {
      color: 'rgba(254, 244, 210, 1)'
    },
    data: weekendData
  };
}

export function getWeekends(startDate: Date, endDate: Date): Date[] {
  const weekends = [];
  const startDT = DateTime.fromJSDate(startDate);
  const endDT = DateTime.fromJSDate(endDate);
  const daysBetween = Math.abs(startDT.diff(endDT, 'days').days);
  let firstWeekendDay;
  for (let i = 0; i < daysBetween; i++) {
    const day = startDT.plus({day: i});
    if (day.weekday === 6 || day.weekday === 7) {
      if (!firstWeekendDay) {
        firstWeekendDay = day;
        if (i === 0 && day.weekday === 7) {
          weekends.push(DateUtils.localDateFromDateTime(day.startOf('day')));
          weekends.push(DateUtils.localDateFromDateTime(day.endOf('day')));
        } else {
          weekends.push(DateUtils.localDateFromDateTime(day.startOf('day')));
        }
      } else if (i === daysBetween + 1) { // last weekend
        if (day.weekday === 6) {
          weekends.push(DateUtils.localDateFromDateTime(day.startOf('day')));
          weekends.push(DateUtils.localDateFromDateTime(day.endOf('day')));
        } else {
          weekends.push(DateUtils.localDateFromDateTime(day.endOf('day')));
        }
      } else {
        if (day.weekday === 6) {
          weekends.push(DateUtils.localDateFromDateTime(day.startOf('day')));
        } else {
          weekends.push(DateUtils.localDateFromDateTime(day.endOf('day')));
        }
      }
    }
  }
  return weekends;
}


export function zoomToTimeSeriesPoint($event: any, chart: any) {
  if ($event.componentType === 'series') {
    const selectedDate = $event.value.date as Date;
    chart.dispatchAction({
      type: 'dataZoom',
      startValue: selectedDate.getTime() - (12 * 3600 * 1000),
      endValue: selectedDate.getTime() + (12 * 3600 * 1000),
    });
  }
}
